module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }